/**
 * Branded numeric types so the compiler catches unit mix-ups between
 * fractions (0..1) and percents (0..100). The Occupancy page has historically
 * mixed these; this module is the single boundary.
 *
 * Use `asFraction01` / `asPercent0100` when you know the value came from a
 * trusted source (e.g. `roundPercentage` already returns a fraction). Use
 * `fractionToPercent` / `percentToFraction` at display boundaries.
 */

declare const __FRACTION01_BRAND: unique symbol;
declare const __PERCENT0100_BRAND: unique symbol;

/** A number in the closed range [0, 1] (plus >1 for "over-capacity"). */
export type Fraction01 = number & { readonly [__FRACTION01_BRAND]: void };

/** A number in the closed range [0, 100] (plus >100 for "over-capacity"). */
export type Percent0100 = number & { readonly [__PERCENT0100_BRAND]: void };

export const asFraction01 = (n: number): Fraction01 => n as Fraction01;
export const asPercent0100 = (n: number): Percent0100 => n as Percent0100;

export const fractionToPercent = (f: Fraction01): Percent0100 =>
  (f * 100) as Percent0100;

export const percentToFraction = (p: Percent0100): Fraction01 =>
  (p / 100) as Fraction01;
